import { onBeforeUnmount, onMounted, ref, watch, type Ref } from 'vue';
import { getRandomPun, type Pun } from '../data/puns';
import type { AirTier } from '../api/tiers';

export function usePuns(tier: Readonly<Ref<AirTier | null>>, modalOpen: Readonly<Ref<boolean>>) {
  const currentPun = ref<Pun>({ text: 'Smoke gets in your eyes. And up in the PSI.' });
  const mascotReacting = ref(false);
  let reactionTimer = 0;
  function shufflePun() {
    if (!tier.value) return;
    currentPun.value = getRandomPun();
    mascotReacting.value = true;
    window.clearTimeout(reactionTimer);
    reactionTimer = window.setTimeout(() => {
      mascotReacting.value = false;
    }, 450);
  }
  watch(
    () => tier.value?.id,
    (value, previous) => {
      if (value && value !== previous) currentPun.value = getRandomPun();
    },
  );
  function handleKeydown(event: KeyboardEvent) {
    if (
      event.defaultPrevented ||
      event.repeat ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      modalOpen.value
    )
      return;
    if (
      event.target instanceof HTMLElement &&
      event.target.closest('button, a, input, textarea, select, [contenteditable], [role="dialog"]')
    )
      return;
    if (event.code === 'Space') {
      event.preventDefault();
      shufflePun();
    }
  }
  onMounted(() => window.addEventListener('keydown', handleKeydown));
  onBeforeUnmount(() => {
    window.clearTimeout(reactionTimer);
    window.removeEventListener('keydown', handleKeydown);
  });
  return { currentPun, mascotReacting, shufflePun };
}
